export default [
  {
    name: "Avenir",
    url: `<iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="800" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FvC8dyIOi2WnqTSrN6E69Fs%2FAvenir%3Fnode-id%3D0%253A1" allowfullscreen></iframe>`,
    members: ["A", "B"]
  },

  {
    name: "Bodoni",
    url: `<iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="800" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FRLyXqLFyYEYwo6UXd1XtM3%2FBodoni%3Fnode-id%3D0%253A1" allowfullscreen></iframe>`,
    members: ["A", "B"]
  },

  {
    name: "Caslon",
    url: `<iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="800" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FN9f1Nlas1h1DG0p3yzLzdj%2FCaslon%3Fnode-id%3D0%253A1" allowfullscreen></iframe>`,
    members: ["A", "B"]
  },

  {
    name: "DIN",
    url: `<iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="800" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2Fy8mkldi5gFe11DuaqKNBKv%2FDIN%3Fnode-id%3D0%253A1" allowfullscreen></iframe>`,
    members: ["A", "B"]
  },
  {
    name: "Europa",
    url: `<iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="800" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FLqON2FDTualDUV0qaBoO8U%2FEuropa%3Fnode-id%3D0%253A1" allowfullscreen></iframe>`,
    members: ["A", "B"]
  },

  {
    name: "Frutiger",
    url: `<iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="800" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2Fif81huZmok42E2UtnSnVbA%2FFrutiger%3Fnode-id%3D0%253A1" allowfullscreen></iframe>`,
    members: ["A", "B"]
  },

  {
    name: "Garamond",
    url: `<iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="800" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FVe3uXzPMBAgvWrgJQcJySK%2FGaramond%3Fnode-id%3D0%253A1" allowfullscreen></iframe>`,
    members: ["A", "B"]
  },

  {
    name: "Helvetica",
    url: `<iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="800" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FzTjnVcwYOAPLM8XVSqKUdM%2FHelvetica%3Fnode-id%3D0%253A1" allowfullscreen></iframe>`,
    members: ["A", "B"]
  }
];
